{
	"title": "Persoonlijke tokens",
	"description": "Tokens waarmee scripts en Claude namens jou werken. Een token kan bijna alles wat jij kunt in het beheer; inloggen, medewerkers en nieuwe tokens regel je alleen zelf.",
	"empty": "Je hebt nog geen tokens.",
	"hint": "cbpat_…{{hint}}",
	"column": {
		"name": "Naam",
		"created": "Aangemaakt",
		"lastUsed": "Laatst gebruikt",
		"actions": "Acties"
	},
	"field": {
		"name": "Naam van het nieuwe token",
		"nameDescription": "Waar je het voor gebruikt, zodat je het later herkent. Bijvoorbeeld: Claude Code op mijn laptop."
	},
	"new": {
		"submit": "Token aanmaken"
	},
	"created": {
		"title": "Token “{{name}}” is aangemaakt",
		"description": "Kopieer het nu en bewaar het veilig: je ziet het hierna nooit meer. Wie het token heeft, kan namens jou in het beheer.",
		"label": "Token",
		"copy": "Kopiëren",
		"copied": "Gekopieerd",
		"done": "Ik heb het bewaard"
	},
	"revoke": {
		"button": "{{name}} intrekken",
		"title": "Token “{{name}}” intrekken?",
		"description": "Scripts en apps die dit token gebruiken, krijgen meteen geen toegang meer. Dit kun je niet terugdraaien.",
		"confirm": "Intrekken"
	},
	"help": {
		"tokens": {
			"title": "Persoonlijk token",
			"area": "Instellingen › Persoonlijke tokens",
			"short": "Een sleutel waarmee een script of Claude (via MCP) namens jou in het beheer werkt. Het kan bijna alles wat jij kunt. Maak per script of apparaat een eigen token.",
			"warning": "Medewerkers uitnodigen, koppellinks, passkeys, wachtwoorden en nieuwe tokens kunnen alleen als je zelf bent ingelogd. Token kwijt? Trek het in en maak een nieuw.",
			"terms": ["personalAccessToken:revoke"]
		},
		"new": {
			"title": "Token aanmaken",
			"area": "Instellingen › Persoonlijke tokens",
			"short": "Na Token aanmaken zie je het token één keer: kopieer het meteen naar je script of naar Claude. In de lijst staan daarna alleen de laatste tekens.",
			"terms": ["personalAccessToken:tokens"]
		},
		"revoke": {
			"title": "Token intrekken",
			"area": "Instellingen › Persoonlijke tokens",
			"short": "Met de prullenbak in de lijst trek je een token in. Wat het token gebruikt, krijgt meteen geen toegang meer. Terugdraaien kan niet: maak dan een nieuw token.",
			"warning": "Wordt je account gedeactiveerd, dan worden al je tokens ingetrokken."
		}
	}
}
